import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Editor from "@/pages/Editor";
import CutEditor from "@/pages/CutEditor";
import SharedCut from "@/pages/SharedCut";
import { Toaster } from "@/components/ui/sonner";

const withLayout = (el) => (
  <ProtectedRoute>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" theme="dark" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={withLayout(<Dashboard />)} />
            <Route path="/projects" element={withLayout(<Projects />)} />
            <Route path="/projects/:id" element={withLayout(<ProjectDetail />)} />
            <Route
              path="/editor/:vid"
              element={
                <ProtectedRoute>
                  <Editor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cuts/:cid"
              element={
                <ProtectedRoute>
                  <CutEditor />
                </ProtectedRoute>
              }
            />
            <Route path="/share/:token" element={<SharedCut />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
